import styled from 'styled-components';

import { ZIndex } from '@rover/constants/src/styles/ZIndex';
import MQ from '@rover/kibble/styles/MediaQuery';

type DatePickerStyleWrapperProps = {
  hasError?: boolean;
};

export const DatePickerStyleWrapper = styled.div<DatePickerStyleWrapperProps>`
  position: relative;

  input {
    height: 40px;
    width: 100%;
    border-radius: ${({ theme }) => theme.radii.secondary};
    padding: ${({ theme }) => theme.space['2x']};
    transition: border-color ease-in-out 0.15s;
    cursor: pointer;
    border: ${({ theme }) => theme.borderWidth.primary} solid
      ${(props): string =>
        props.hasError ? props.theme.colors.border.error : props.theme.colors.border.primary};

    &:focus {
      border-color: ${({ theme }) => theme.colors.border.input_focus};

      ${MQ.XS_DOWN.toString()} {
        font-size: 16px;
      }
    }

    &:disabled {
      font-weight: 500;
      opacity: 1;
    }
  }

  .DayPickerInput {
    width: 100%;

    &-OverlayWrapper {
      top: ${({ theme }) => theme.space['6x']};
    }

    &-Overlay {
      width: 100%;
      z-index: ${ZIndex.DROPDOWN.toString()};
      position: absolute;
      border-radius: 4px;
      border: ${({ theme }) => `${theme.borderWidth.primary} solid ${theme.colors.border.primary}`};

      ${MQ.XS_DOWN.toString()} {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        background: ${({ theme }) => theme.background.overlay};
        border: none;
        border-radius: 0;
      }
    }

    ${MQ.XS_DOWN.toString()} {
      &-Overlay-Container {
        position: relative;
        background: ${({ theme }) => theme.background.primary};
        border-radius: 16px 16px 0 0;
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
      }
    }
  }

  .DayPicker {
    width: 100%;

    ${MQ.SM_UP.toString()} {
      &-Caption {
        padding: 0 ${({ theme }) => theme.space['4x']};
      }
    }

    &-Caption > div {
      color: ${({ theme }) => theme.textColor.primary};
      font-size: ${({ theme }) => theme.heading['200'].fontSize};
      font-weight: ${({ theme }) => theme.heading['200'].fontWeight};
      text-transform: capitalize;
    }

    &-Month {
      width: 100%;
      border-collapse: unset;
      border-spacing: 1px;
      margin: 0 16px;
    }

    &-Weekday {
      color: ${({ theme }) => theme.textColor.tertiary};
      font-size: ${({ theme }) => theme.heading['100'].fontSize};
    }

    &-Day {
      border-radius: 0;
      height: 40px;
      width: 40px;
      min-width: 40px;
      color: ${({ theme }) => theme.textColor.secondary};
      font-size: ${({ theme }) => theme.text['100'].fontSize};
      font-weight: ${({ theme }) => theme.heading['200'].fontWeight};
      position: relative;

      ${MQ.XS_DOWN.toString()} {
        height: 50px;
        width: 50px;
        min-width: 50px;
      }

      &:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):not(
          .DayPicker-Day--between
        ):hover {
        border-radius: ${({ theme }) => theme.space['2x']};
      }

      &--start {
        &:after {
          background-color: ${({ theme }) =>
            theme.background.interactive.button_primary_base} !important;
          bottom: 0;
          content: '';
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          z-index: -1;
        }
        &.DayPicker-Day--selected {
          &:after {
            left: 50%;
          }
        }
      }

      &--end {
        &:before {
          background-color: ${({ theme }) =>
            theme.background.interactive.button_primary_base} !important;
          bottom: 0;
          content: '';
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          z-index: -1;
        }
        &.DayPicker-Day--selected {
          &:before {
            right: 50%;
          }
        }
      }

      &--selected {
        &:not(.DayPicker-Day--outside) {
          background-color: ${({ theme }) => theme.background.primary};
          color: ${({ theme }) => theme.textColor.primary};
          border: ${({ theme }) => theme.borderWidth.primary} solid
            ${({ theme }) => theme.colors.interactive_border.primary_active};
        }
        &:not(.DayPicker-Day--between):not(.DayPicker-Day--disabled) {
          border-radius: 8px;
          &.DayPicker-Day--between {
            background-color: ${({ theme }) =>
              theme.background.interactive.button_primary_base} !important;
            color: ${({ theme }) => theme.textColor.secondary};
            &:hover {
              border-radius: 0;
              background-color: ${({ theme }) => theme.background.primary};
              color: ${({ theme }) => theme.textColor.primary};
            }
          }
        }
      }

      &--disabled {
        color: ${({ theme }) => theme.colors.interactive_text.disabled} !important;
      }
    }
  }
`;
